export interface PaginatedApiResource<ApiItem> {
  items: ApiItem[];
  page: number;
  page_size: number;
  total_items: number;
}

export interface PaginatedResult<DomainItem> {
  items: DomainItem[];
  page: number;
  pageSize: number;
  totalItems: number;
}

export function mapPaginatedResource<ApiItem, DomainItem>(
  resource: PaginatedApiResource<ApiItem>,
  mapItem: (apiItem: ApiItem) => DomainItem
): PaginatedResult<DomainItem> {
  return {
    items: resource.items.map(mapItem),
    page: resource.page,
    pageSize: resource.page_size,
    totalItems: resource.total_items,
  };
}
